(ns client-portal.client.smart-ordering.sessions.utterances.views
  (:require [client-portal.client.anonymous.data :as anon.d]
            [client-portal.client.layout :as l]
            [client-portal.client.smart-ordering.sessions.utterances.data]
            [client-portal.client.vi.components.tag :as tag]
            [client-portal.client.voice-insights.data :as vi.d]
            [client-portal.client.voice-insights.empty-state :as empty-state]
            [client-portal.client.voice-insights.sessions.utterances.views :as vi.utterances]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.util :as util]))

(defn utterances-table []
  (let [utterances- (re/subscribe [:smart-ordering/utterances-flattened-])
        anon-ctx @(re/subscribe [:anonymous/ctx-])
        loading?- (re/subscribe [:smart-ordering/utterances-list-loading?-])
        has-more?- (re/subscribe [:smart-ordering/utterances-has-more?-])
        next-page-loading?- (re/subscribe [:smart-ordering/utterances-next-page-loading?-])
        next-page- (re/subscribe [:smart-ordering/utterances-next-page-])
        header-height- (re/subscribe [:smart-ordering/header-height-])
        admin?- (re/subscribe [:account/admin-role?-])
        theme- (re/subscribe [:core/theme-])
        {selected-id :conversation-id
         selected-start :start} @(re/subscribe [:smart-ordering/selected-session-])
        admin? @admin?-]
    [alc/table {:no-data-text "No sessions to display"
                :loading-more? @next-page-loading?-
                :loading? @loading?-
                :scroll-container-id l/core-scroll-content-id
                :bottom-px-buffer 200
                :on-bottom-buffer (when @has-more?-
                                    #(re/dispatch [:smart-ordering/load-utterances [nil {:page @next-page-}]]))
                :has-more-rows? true
                :flex-vals (filterv identity
                                    [(when admin? "0 0 100px")
                                     "0 0 120px"
                                     "0 0 50px"
                                     "0 0 210px"
                                     "0 0 85px"
                                     1
                                     1.3])
                :sticky-headers? true
                :no-data-material-icon :inventory_2
                :no-data-style empty-state/base-container-style
                :no-data-text-style {:color (style/alc-color "Text/primary_header")
                                     :font-size 20
                                     :font-weight 400
                                     :line-height 1.4}
                :row-style {:height :auto
                            :align-items :flex-start}
                :header-top @header-height-
                :header-style {:border-top :none}
                :headers (filterv identity
                                  [(when admin? "Conversation ID")
                                   "Timestamp"
                                   "Offset"
                                   "Tags"
                                   "Speaker"
                                   "Transcript"
                                   "Description"])
                :rows (map-indexed
                        (fn [idx {:keys [conversation-id dataset-id conversation-ts offset tag-details speaker transcript start]}]
                          (let [first-in-convo? (-> @utterances- (get (dec idx)) :conversation-id (not= conversation-id))
                                tag-details (distinct tag-details)
                                selected? (and (= selected-id conversation-id)
                                               (= selected-start start))]
                            {:key idx
                             :cells (filterv identity
                                             [(when admin?
                                                (if first-in-convo?
                                                  {:label conversation-id
                                                   :copyable? true
                                                   :style {:color (style/alc-color "Text/secondary")
                                                           :white-space :nowrap}}
                                                  ""))
                                              {:label (if first-in-convo?
                                                        [:span {:style {:color (style/alc-color "Text/secondary")}}
                                                         conversation-ts]
                                                        "")}
                                              {:label offset}
                                              {:label (into [:div {:style {:display :flex
                                                                           :flex-wrap :wrap
                                                                           :gap 8}}]
                                                            (map (fn [t]
                                                                   [tag/utterance-tag-pill (assoc t :show-description? true)])
                                                                 tag-details))}
                                              {:label [:div {:style {:display :flex
                                                                     :align-items :center
                                                                     :gap 6}}
                                                       (if (not= speaker "user")
                                                         [vi.utterances/headset-icon {:color "#FEAC2A"}]
                                                         [vi.utterances/utterance-icon {:color "#2594FB"}])
                                                       [:span {:style {:color (style/alc-color "Text/primary")
                                                                       :font-size 12
                                                                       :font-weight style/font-regular-weight}}
                                                        (vi.d/->speaker-display-name speaker)]]}
                                              {:label [:div {:style {:background-color (if (= @theme- :dark-mode)
                                                                                         "#343637"
                                                                                         "rgba(0, 0, 0, 0.3)")
                                                                     :border-radius 6
                                                                     :padding "6px 12px"
                                                                     :width "100%"}}
                                                       [:span {:style {:color (style/alc-color "Text/primary")
                                                                       :font-size 12
                                                                       :font-style :italic
                                                                       :line-height 1.5}}
                                                        (str "\"" (anon.d/text anon-ctx transcript) "\"")]]}
                                              {:label (into [:div {:style {:display :flex
                                                                           :flex-direction :column
                                                                           :gap 10}}]
                                                            (map (fn [{:keys [description] :as t}]
                                                                   [:div {:style {:display :flex
                                                                                  :flex-direction :column
                                                                                  :gap 1}}
                                                                    (when (> (count tag-details) 1)
                                                                      [:span {:style {:color (style/alc-color "Text/primary")
                                                                                      :font-size 12
                                                                                      :font-weight 400
                                                                                      :line-height 1.5}}
                                                                       (tag/tag->display-name t)])
                                                                    [:span {:style {:color (style/alc-color "Text/primary")
                                                                                    :font-size 12
                                                                                    :font-weight 400
                                                                                    :line-height 1.5}}
                                                                     (or (not-empty description) "N/A")]])
                                                                 tag-details))}])
                             :on-click #(re/dispatch [:smart-ordering/toggle-session-panel {:conversation-id conversation-id
                                                                                            :dataset-id dataset-id
                                                                                            :conversation-ts conversation-ts
                                                                                            :start start}])
                             :hover-style (when selected?
                                            {:background-color (style/alc-color "Background/active_secondary")})
                             :style (when selected?
                                      {:background-color (style/alc-color "Background/active_secondary")})}))
                        @utterances-)}]))

(defn utterances-view []
  (let [utterances @(re/subscribe [:smart-ordering/utterances-flattened-])]
    (cond
      (util/nil-or-loading? utterances) [empty-state/loading-utterances-card]
      (not-empty utterances) [utterances-table]
      :else [empty-state/no-utterances-card])))
